import { Link } from "react-router-dom";

import { Card, BlockStack, InlineGrid, Text, Button, Box } from '@shopify/polaris';

const FeatureCard = ({ title, description, buttonText, linkUrl, image, stripeBackground }) => {
  return(
    <InlineGrid columns={{ xs: "1fr", md: "2fr 5fr" }} gap="400">
      <Box
        as="section"
        paddingInlineStart={{ xs: 400, sm: 0 }}
        paddingInlineEnd={{ xs: 400, sm: 0 }}
      >
        <BlockStack gap="400">
          <Text as="h3" variant="headingMd">
            {title}
          </Text>
        </BlockStack>
      </Box>
      <Link to={linkUrl + window.location.search} className="feature-card-link">
        <Card roundedAbove="sm">
          <div style={{ borderBottom: `2px solid ${stripeBackground || 'transparent'}`, paddingBottom: '8px' }}>
            <BlockStack gap="400">
              <Text as="p" variant="bodyMd">
                {description}
              </Text>

              <Button icon={image}>{buttonText}</Button>
            </BlockStack>
          </div>
        </Card>
      </Link>
    </InlineGrid>
  )
}

export default FeatureCard;
